module.exports = __webpack_public_path__ + "static/img/4bg_2.da41ce4.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_2.png
// module id = 704
// module chunks = 1